import { Component } from '@angular/core';

@Component({
  selector: 'app-common-landing-page',
  standalone: true,
  imports: [],
  templateUrl: './common-landing-page.component.html',
  styleUrl: './common-landing-page.component.scss'
})
export class CommonLandingPageComponent {

}
